(function () {
    'use strict';

    angular.module('swif.interventions')

    .config(route)
    .controller('RequestsController', RequestsController)
    .controller('RequestController', RequestController)
    .controller('RequestRegroupModalController', RequestRegroupModalController)
    .controller('ContributionModalController', ContributionModalController)
    .controller('RequestDetailsModalController', RequestDetailsModalController);

    route.$inject = ['$routeProvider', 'swifInterventionsConstant'];
    function route ($routeProvider, constant) {
        $routeProvider.when(constant.request.routes.table_view, {
            templateUrl: 'partials/openstc/requests_table_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when(constant.request.routes.explorer_view, {
            templateUrl: 'partials/openstc/requests_explorer_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when(constant.request.routes.commission_view, {
            templateUrl: 'partials/openstc/requests_commission_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.request.resolveCommissionData();
                }]
            }
        });
    }


    function RequestsController ($scope, $location, $uibModal, swif, openstc, data, swifMomentUtility, gettextCatalog,
        swifOpenbaseCompanyService, AttachmentService) {

        'ngInject';
        console.log('init RequestsController');
        var user = swif.user.getAuthenticatedUserData();
        $scope.fullView = _.contains(user.access_rights, 'openstc_full_view');
        $scope.loading = {contribs: {}};
        $scope.currentSession = swif.settings.get('token');

        const locationPrefix = '/interventions/requests';
        if ($location.path() == `${locationPrefix}/table_view` && (!$scope.fullView || _.contains(user.access_rights, 'CITIZEN'))) {
            // Redirect citizen if he tries to go to the table_view
            $location.path(`${locationPrefix}/explorer_view`);
            return;
        }
        $scope.debug = $location.search().debug;
        $scope.cart = swif.cart;
        $scope.modules = swif.module.modules;

        $scope.countFilter = openstc.request.getCountFilter();
        $scope.data = data;
        $scope.requests = data.requests;
        $scope.canManageContribs = swif.user.getAuthenticatedUserData().can_manage_contribs;

        $scope.settings = {};
        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.settings.request_report_date_replace = company.request_report_date_replace;
            $scope.processingTimesEnable = company.processing_times_enable;
        });

        // TG-3556 - specific commission view for Drôme
        $scope.isDrome = swif.settings.app.features.isDrome;

        $scope.preModal = function(data) {
            if (data.action.id === 'contrib') {
                data.model = {
                    'ask_id': [data.model.id, data.model.name],
                    'imageClicked': false
                }
            }
            $scope.data.preModal(data);
        };
        $scope.actionsCallback = function(error, data) {
            if (!error) {
                if (data.action.id === 'contrib') {
                    if (data.model.confirm || data.model.invalidate || data.model.note || document.getElementById('attachment').files.length > 0) {
                        $scope.data.requests.getItem(data.model.ask_id[0])
                            .then(function(item) {
                                item.contribs_count += 1;
                                // Reload contributions if opened
                                if ($scope.data.requests.currentItem) {
                                    $scope.contribs.refresh();
                                }
                            });
                    }
                } else if (data.action.id === 'regroup') {
                    $scope.data.requests.getItem(data.model.regroup_ask_id[0])
                        .then(function(item) {
                            item.contribs_count += 1;
                        });
                    $scope.data.requests.refresh();
                } else if (data.action.id === 'toggle-contrib') {
                    if ($scope.requests.currentItem && $scope.requests.currentItem.id === data.model.id) {
                        $scope.requests.currentItem = undefined;
                    } else {
                        $scope.requests.currentItem = data.model;
                    }
                }
            }
            $scope.data.callback(error, data);
        }
        $scope.actionsPreValidate = function(data) {
            var params;
            if (data.action.id === 'contrib') {
                if (data.model.confirm || data.model.invalidate || data.model.note || document.getElementById('attachment').files.length > 0) {
                    swif.data.create('ask_contrib', data.model).then(function (obj) {
                        swif.message.addInfo('save ok');
                    });
                }
                return true;
            } else if (data.action.id === 'regroup') {
                params = {
                    args: [data.model.id, data.model.regroup_ask_id[0]]
                };
                swif.data.updateObj(params, data.model);
            } else if (data.action.id === 'details') {
                // Get all attachments
                AttachmentService.addAttachments(data.model)

                // Open details modal
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/openstc/request_details_modal.html',
                    controller: 'RequestDetailsModalController',
                    size: 'lg',
                    resolve: {
                        modalParams: function () {
                            return data;
                        }
                    }
                });
            }
            return $scope.data.preValidate(data);
        };

        $scope.preModalContribs = function(data) {
            data.model.note = data.model.note ? data.model.note : ''; // Why do we need this here and nowhere else ?
            $scope.contribs.preModal(data);
        };

        $scope.preValidateContribs = function(data) {
            return $scope.contribs.preValidate(data);
        };

        $scope.callbackContribs = function(error, data) {
            $scope.contribs.callback(error, data);
        };

        $scope.$watch('requests.currentItem', watchRequest);
        $scope.$watch('requests.items', watchRequestItems);

        $scope.getTooltip = openstc.request.getTooltip;
        $scope.showValidation = openstc.request.showValidation;

        $scope.siteFilter = {fields: ['name', 'type_id', 'site_parent_id', 'surface', 'code', 'lat', 'long', 'street', 'street2', 'zip', 'city']};

        // Removes all html tags and returns a string instead
        $scope.getPopoverContent = function(content) {
            return String(content).replace(/<[^>]+>/gm, '')
                                .replace(/&[a-zA-Z0-9]+;/gm, '')
                                .replace(/\[[0-9]*]/gm, '');
        }

        function getDatePopoverContent(request, date, date_alt, date_alt_str) {
            var timeago = swifMomentUtility.timeago(date);
            var specialday = swifMomentUtility.get_specialday(date);

            var tooltip = '<em>';
            if (request.create_uid[1]) {
                tooltip += request.create_uid[1] + ',<br />';
            }
            tooltip += timeago + '</em><br />';
            if (date_alt && date_alt.substring(0, 16) !== date.substring(0, 16)) {
                tooltip += '<strong>' + date_alt_str + ':</strong> ';
                tooltip += swifMomentUtility.formatDatetime(date_alt)+ '<br />';
            }
            if (request.communication_channel_id) {
                tooltip += '<strong>' + gettextCatalog.getString('Communication channel') + ':</strong> ';
                tooltip += request.communication_channel_id[1]+ '<br />';
            }
            if (specialday !== undefined) {
                tooltip += gettextCatalog.getString('Warning')+ ': ';
                tooltip += specialday+ '<br />';
            }

            return tooltip;
        }

        $scope.getCreationDatePopoverContent = function(request) {
            return getDatePopoverContent(
                request,
                request.create_date,
                request.current_date,
                gettextCatalog.getString('Report date')
            );
        }

        $scope.getReportDatePopoverContent = function(request) {
            return getDatePopoverContent(
                request,
                request.current_date,
                request.create_date,
                gettextCatalog.getString('Creation date')
            );
        }

        $scope.promoteFile = function(contrib) {
            var userContext = swif.user.getAuthenticatedUser().context;
            swif.data.callKw(
                'ask_contrib',
                'promote_attachment',
                [parseInt(contrib.id, 10)],
                {context: userContext}
            ).then(function (rdata) {
                $scope.contribs.refresh();
            });
        }

        function watchRequest (newV, oldV) {
            if (newV) {
                swif.message.loading($scope.loading.contribs);
                openstc.request.createCollectionContribs(newV)
                .then(function(contribs) {
                    swif.message.loading($scope.loading.contribs, 'ok');
                    $scope.contribs = contribs;
                }, function() {
                    swif.message.loading($scope.loading.contribs, 'ko');
                });

                $scope.citizenContact = createCitizenContact(newV);
            }
        }

        function createCitizenContact(request) {
            if(!request.partner_address) {
                var citizenContact = {
                    'email': request['people_email'],
                    'phone': request['people_phone'],
                    'name': request['people_name']
                };
            }
            return citizenContact;
        }

        function watchRequestItems(newV, oldV) {
            var request_priority_ids = [];

            angular.forEach(newV, function(item) {
                if (!item.claimer_priority_obj && item.claimer_priority.length > 0) {
                    request_priority_ids.push(item.claimer_priority[0]);
                }
            });

            if (request_priority_ids.length > 0) {
                var filter = {fields: ['color']};
                swif.data.addFilter(filter, 'id', 'in', request_priority_ids);
                swif.data.get('intervention_request_priority', undefined, filter).then(priorities => {

                    angular.forEach(priorities, function(priority) {
                        angular.forEach(newV, function(item) {
                            if (priority.id === item.claimer_priority[0]) {
                                item.claimer_priority_obj = priority;
                            }
                        });
                    });
                });
            }
        }
    }

    function RequestController($scope, swif, openstc, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init RequestController');

        var user = swif.user.getAuthenticatedUserData(),
            previousTemplate;

        $scope.is = {
            dst: _.contains(user.access_rights, 'DIRE'),
            manager: _.contains(user.access_rights, 'MANA'),
            accueil: _.contains(user.access_rights, 'RCPT'),
            current_claimer: $scope.model.create_uid && user.id == $scope.model.create_uid[0],
            current_manager: $scope.model.manager_id && user.id == $scope.model.manager_id[0]
        };

        // TG-3556 - specific commission view for Drôme
        $scope.isDrome = swif.settings.app.features.isDrome;

        $scope.can = {
            request_for_someone_else: $scope.is.dst || $scope.is.manager || $scope.is.accueil,
            is_manager: $scope.is.dst || $scope.is.manager,
            view_claimer_priority: _.contains(user.access_rights, 'openstc_view_priority_applicant') ||
                                    $scope.is.current_claimer,
            edit_claimer_priority: (_.contains(user.access_rights, 'openstc_edit_priority_applicant') ||
                                    $scope.is.current_claimer) && $scope.model.state !== 'valid',
            view_service_priority: _.contains(user.access_rights, 'openstc_view_priority_service') ||
                                    $scope.is.current_manager,
            edit_service_priority: (_.contains(user.access_rights, 'openstc_edit_priority_service') ||
                                    $scope.is.current_manager) && $scope.model.state !== 'valid',
            view_retained_priority: _.contains(user.access_rights, 'openstc_view_priority_retained') ||
                                    $scope.is.current_claimer ||
                                    $scope.is.current_manager,
            edit_retained_priority: (_.contains(user.access_rights, 'openstc_edit_priority_retained') ||
                                    $scope.is.current_manager ) && $scope.model.state !== 'valid',
            view_budget_priority: _.contains(user.access_rights, 'openstc_view_priority_budget') ||
                                    $scope.is.current_claimer ||
                                    $scope.is.current_manager,
            edit_budget_priority: $scope.isDrome ?
                                    (_.contains(user.access_rights, 'openstc_edit_priority_budget') ||
                                    $scope.is.current_manager ) && $scope.is.manager
                                    :
                                    (_.contains(user.access_rights, 'openstc_edit_priority_budget') ||
                                    $scope.is.current_manager ) && $scope.model.state !== 'valid',
            edit_report_date: _.contains(user.access_rights, 'openstc_edit_report_date')
        };

        // Full view access
        $scope.fullView = _.contains(user.access_rights, 'openstc_full_view');
        $scope.activeTabIndex = $scope.fullView ? 0 : 1;


        if (!$scope.fullView) {
            $scope.model.useATemplate = true;
        }


        // Load map only when tab is active to prevent glitches
        $scope.tabOpened = false;
        $scope.loadMap = function() {
            $scope.tabOpened = true;
        }

        $scope.tab = {
            requester : $scope.can.request_for_someone_else ? true : false,
            request: $scope.can.request_for_someone_else ? false : true
        };

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.request_priority_enable = company.request_priority_enable;
            $scope.request_priority_require = company.request_priority_require;
            $scope.request_report_date_enable = company.request_report_date_enable;
            $scope.request_communication_channel_enable = company.request_communication_channel_enable;
            $scope.request_communication_channel_require = company.request_communication_channel_require;
            $scope.projectAskTemplateRequired = company.project_ask_template_require;

            if ($scope.projectAskTemplateRequired){
                $scope.model.useATemplate = true;
            }

            // If the DI exists and was created with a label, we give the possibility to change it to a label
            if (typeof $scope.model.type_id === 'boolean' && $scope.model.type_id === false){
                $scope.projectAskTemplateRequired = false;
                $scope.model.useATemplate = false;
            }


            setDefaultCommunicationChannel();
        });

        if ($scope.model.type_id && !$scope.model.useATemplate) {
            $scope.model.useATemplate = true;
        }
        $scope.hasTemplate = false;

        swif.data.getContentRange('intervention_request_category')
        .then(function (count) {
            if (count > 0) {
                $scope.hasTemplate = true;
            }
        });

        updateFilters();
        $scope.onIsCitizenChange = onIsCitizenChange;
        $scope.onPartnerAddressChange = onPartnerAddressChange;
        $scope.deleteRequester = deleteRequester;
        $scope.onPartnerChange = onPartnerChange;
        $scope.onChangeTemplate = onChangeTemplate;
        $scope.$watch('model.equipment_id', watchEquipmentId);
        $scope.$watch('model.custom_fields', watchCustomFieds);
        if ($scope.model.id === undefined) {
            // Set initial report date
            $scope.model.current_date = new Date();

            //load current user
            swif.user.getPartnerAddress(['name', 'complete_name', 'partner_id']).then(function (pa) {
                if (pa) {
                    $scope.model.partner_address = [pa.id, pa.complete_name || pa.name];
                    $scope.onPartnerAddressChange(pa);
                }
            });
        }
        $scope.budgetYears = [];
        $scope.filtersBudget = {fields: ['id', 'name', 'date_from', 'date_to']};
        $scope.onChangeCrossoveredBudget = function (budget){
            let yearFrom = budget.date_from.substring(0,4);
            let yearTo = budget.date_to.substring(0,4);
            for (let year=yearFrom; year<=yearTo ;year++){
                $scope.budgetYears.push(parseInt(year));
            }
        };
        $scope.initPriorities = function (){
            if (!$scope.model.department_estimated_amount){
                $scope.model.department_estimated_amount = 0;
            }
            if (!$scope.model.budget_retained_amount){
                $scope.model.budget_retained_amount = 0;
            }
            if ($scope.model.crossovered_budget){
                swif.data.get('crossovered_budget', $scope.model.crossovered_budget[0])
                    .then(function (data) {
                        $scope.onChangeCrossoveredBudget(data);
                    });
            }
        };

        /**
         * Sets the default communication channel
         */
        function setDefaultCommunicationChannel() {
            // When creating a new intervention request
            if ($scope.model.id === undefined && $scope.request_communication_channel_enable) {
                if (user.communication_channel_id) {
                    // Use the user defined default communication channel if it is defined
                    $scope.model.communication_channel_id = user.communication_channel_id;
                } else if(_.contains(user.access_rights, 'CITIZEN')) {
                    // Use 'OpenGST' as default channel for any user that is a part of 'Citoyen' group
                    $scope.model.communication_channel_id = [1, 'OpenGST'];
                } else {
                    // Otherwise, use the global default one
                    var filter = {};

                    swif.data.addFilter(filter, 'active', '=', true);
                    swif.data.addFilter(filter, 'default', '=', true);

                    swif.data.get('intervention_request_communication_channel', undefined, filter)
                        .then(function (channels) {
                            if (channels.length) {
                                $scope.model.communication_channel_id = [channels[0].id, channels[0].name];
                            }
                        });
                }
            }
        }

        function updateFilters() {
            $scope.filters = openstc.request.getFilters($scope.model);
            if (!$scope.fullView) {
                swif.data.addFilter($scope.filters.ask_category, 'is_used_by_mobile', '=', true);
            }
        }
        function onIsCitizenChange (newV) {
            if (newV) {
                if ($scope.model.partner_address) {
                    $scope.model.partner_address = false;
                    $scope.onPartnerAddressChange();
                }
                if ($scope.model.partner_id) {
                    $scope.model.partner_id = false;
                    $scope.onPartnerChange();
                }
            } else {
                if ($scope.model.people_name) {
                    $scope.model.people_name = false;
                }
                if ($scope.model.people_email) {
                    $scope.model.people_email = false;
                }
                if ($scope.model.people_phone) {
                    $scope.model.people_phone = false;
                }
            }
        }
        function onPartnerAddressChange (partner_address) {
            if (partner_address) {
                if (partner_address.partner_id && !$scope.model.partner_id) {
                    $scope.model.partner_id = partner_address.partner_id;
                    var partner = {id: partner_address.partner_id[0], name: partner_address.partner_id[1]};
                    $scope.onPartnerChange(partner);
                }
            }
        }
        function onPartnerChange (newV) {
            updateFilters();
            if (newV) {
                swif.data.get('partner', newV.id).then(function (partner) {
                    $scope.currentPartner = partner;
                    if (partner.technical_service_id && !$scope.model.service_id) {
                        $scope.model.service_id = partner.technical_service_id;
                    }
                    if (partner.technical_site_id && !$scope.model.site1) {
                        $scope.model.site1 = partner.technical_site_id;
                    }
                });
            } else {
                delete $scope.currentPartner;
            }
        }
        function deleteRequester () {
            delete $scope.model.partner_address;
            delete $scope.model.partner_id;
            $scope.onPartnerAddressChange();
            $scope.onPartnerChange();
        }
        function onChangeTemplate (template) {
            var exclude_properties = ['id', '$$hashKey', '_type'];

            _.forOwn(template, function (value, key) {
                if (!_.contains(exclude_properties, key)) {
                    // Change model value if empty or is the same as the
                    // previous selected template
                    // Always update service_id on limited view
                    if (_.isEmpty($scope.model[key]) || (previousTemplate && $scope.model[key] === previousTemplate[key]) || (!$scope.fullView && key == 'service_id')) {
                        $scope.model[key] = value;
                    }
                    if (key == 'name'){
                        $scope.model[key] = value;
                    }
                }
            });

            if (template.id) {
                $scope.model._isTemplate = false;
            }

            previousTemplate = template;
        }
        function watchEquipmentId (newV, oldV) {
            if (newV) {
                updateFilters();
            } else if (!angular.equals(newV, oldV)) {
                updateFilters();
            }
        }
        function watchCustomFieds (newV) {
            if (newV) {
                let filter = {};
                filter.fields = ['id', 'name'];
                swif.data.setLimit(filter, 1);
                swif.data.addExtraFilter(filter, 'service', 'name', '=', newV);
                swif.data.searchRead('department', filter).then(function(data) {
                    if (data.records && data.records.length > 0) {
                        const service = data.records[0];
                        $scope.$parent.$parent.model.service_id = [service.id, service.name];
                    }
                });
            }
        }
    }

    function RequestRegroupModalController ($scope, swif, $sce) {
        'ngInject';
        $scope.filter = {};
        swif.data.addFilter($scope.filter, 'state', 'in', ['draft', 'wait', 'valid']);
        swif.data.addFilter($scope.filter, 'id', '!=', $scope.model.id); // Don't include current request in results
        swif.data.sortOn($scope.filter, 'id', 'DESC');

        $scope.formatRequestNames = function(item) {
            var askLabel = `<span class="label ask-id-label">D.${item.id}</span>&nbsp;&nbsp;`;
            var itemName = askLabel + item.name;
            return $sce.trustAsHtml(itemName);
        }

        $scope.onRequestSelect = function(request) {
            swif.data.get('intervention_request', request.id).then(request => {
                $scope.destRequest = request;
            });
        }
    }

    function ContributionModalController($scope) {
        $scope.fileName = false;
        $scope.previewImage = false;

        if ($scope.model.id && $scope.model.attachment !== false) {
            $scope.model.imageClicked = true;
            $scope.fileName = $scope.model.attachment_name;
        }

        $scope.fileChanged = function() {
            $scope.model.imageClicked = true
            $scope.previewImage = false;
            if (document.getElementById('attachment').files.length) {
                var file = document.getElementById('attachment').files[0];
                if (file) {
                    $scope.fileName = file.name;
                    $scope.model.attachment_name = file.name;
                    let supportedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function(e) {
                        $scope.model.attachment = e.target.result.split(',')[1];

                        // Display preview if the attachment is an image
                        if (supportedTypes.indexOf(file.type) !== -1) {
                            $scope.previewImage = e.target.result;
                        }
                    }
                }
            }
        }

        $scope.removeFile = function() {
            angular.element('#attachment').val(null);
            $scope.fileName = false;
            $scope.previewImage = false;
            $scope.model.imageClicked = false;
            $scope.model.attachment = false;
            $scope.model.attachment_name = false;
            $scope.model.attachment_promoted = false;
        }
        $scope.toggleContribButtons = function(value) {
            if (value === 'confirm') {
                $scope.model.confirm = !$scope.model.confirm;
                if ($scope.model.confirm) {
                    $scope.model.invalidate = false;
                }
            } else if (value === 'invalidate') {
                $scope.model.invalidate = !$scope.model.invalidate;
                if ($scope.model.invalidate) {
                    $scope.model.confirm = false;
                }
            }
        }
    }

    function RequestDetailsModalController($scope, $uibModalInstance, $timeout, modalParams, swif, openstc, swifRouteService, swifCartoLeafletService, swifOpenbaseKeysService,
     AttachmentService) {
        'ngInject';

        const cartoService = swifCartoLeafletService;
        // Init model with data recieved in params
        $scope.model = modalParams.model;

        // Retrieve requests collection and find data position in the items array
        // to switch to the next request with the modal arrows
        $scope.requestsCollection = swif.collection.getCollection('requests');
        $scope.requestIndex = $scope.requestsCollection.items.findIndex(req => req.id === $scope.model.id);

        const user = swif.user.getAuthenticatedUserData();
        const isManager = (_.includes(user.access_rights, 'MANA') || _.includes(user.access_rights, 'ELU'));
        const isManagerOrAsker = (isManager || _.includes(user.access_rights, 'RCPT'));

        $scope.isManager = isManager;
        $scope.isManagerOrAsker = isManagerOrAsker;
        $scope.extra = '';
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.setExtra = function(view) {
            if (view === 'map') {
                swifRouteService.check({resources: ['leaflet']}).then(function () {
                    $scope.extra = view;
                });
            } else {
                $scope.extra = view;
            }
        }

        $scope.siteFilter = { fields: ['name', 'type_id', 'site_parent_id', 'surface', 'code', 'lat', 'long', 'street', 'street2', 'zip', 'city'] };

        function refreshData() {
            // Init extra view
            $scope.intervention = undefined;
            $scope.tasks = undefined;

            swif.data.get('site', $scope.model.site1[0], { fields: ['id', 'geo_polygon', 'site_parent_id']}).then(function (taskSite) {
                $scope.taskSite = taskSite;

                if (($scope.extra === '' || $scope.extra === 'photos') && $scope.model.geo_point) {
                    $scope.setExtra('map');
                } else if ($scope.extra === 'map' && !$scope.model.geo_point) {
                    $scope.setExtra('photos');
                } else if ($scope.extra === 'map' && $scope.model.geo_point) {
                    // Reinit map if map tab is already selected.
                    // The map has to disappear and reappear of the DOM to be refreshed...
                    $scope.setExtra('');
                    $timeout(() => {
                        $scope.setExtra('map');
                    }, 100);
                }
            });
            // Watch model attachments loading
            $scope.$watch('model._attachments', function (newV, oldV) {
                $scope.attachments = newV;
            });
            $scope.$watch('model._attachments_img', function (newV, oldV) {
                $scope.images = newV;
            });

            // Get keys
            if (isManager) {
                let keysFilter = {};
                swif.data.addFilter(keysFilter, 'site_ids', 'in', [$scope.model.site1[0]])
                swif.data.get('key', undefined, keysFilter).then(function (keys) {
                    $scope.keys = keys;
                });
            }

            // Load advanced view
            if (isManagerOrAsker || $scope.model.advanced_view) {
                $scope.tasks = []
                let filter = {}

                swif.data.addFilter(filter, 'ask_id', '=', $scope.model.id)
                swif.data.get('task', undefined, filter).then(function (tasks) {
                    $scope.tasks = tasks;
                });

                swif.data.callKw('intervention_request', 'get_linked_intervention', [$scope.model.id]).then(function (intervention) {
                    // param intervention can be false
                    if(intervention) {
                        $scope.intervention = intervention;
                        $scope.intervention._type = 'intervention'; // Needed for swifStateLabel
                    }
                })

            }
        }

        // FIRST DATA INIT
        refreshData();

        // Init map
        $scope.onMapInitialized = function (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                $scope.map.setZoom($scope.model.osm_zoom);
            }
            if ($scope.model.geo_point) {
                // Display site polygon, parents polygons and ask geo_point
                cartoService.getParentSiteWithPolygon($scope.taskSite.id).then(parentSites => {
                    // Add current site to his parents
                    var sites = parentSites.concat([$scope.taskSite]);

                    var polygons = cartoService.setChildAndParentsPolygons(sites);
                    var layer = L.featureGroup(polygons);
                    layer.addTo($scope.map);

                    let marker = cartoService.getMarkerFromPoint($scope.model.geo_point);
                    if (marker) {
                        marker.addTo(layer);
                        $scope.map.setView(marker.getLatLng());
                    }
                    if (!$scope.model.geo_point && !_.isEmpty(polygons)) {
                        // We want to center the map to the current site (the last item)
                        var bounds = _.last(polygons).getBounds();
                        $scope.map.fitBounds(bounds);
                    }
                });
            }
        };

        $scope.previousRequest = function () {
            $scope.model = $scope.requestsCollection.items[$scope.requestIndex - 1];
            if ($scope.model.attachment_count){
                AttachmentService.addAttachments($scope.model)
            };
            $scope.requestIndex -= 1;
            refreshData();
        }

        $scope.nextRequest = function () {
            $scope.model = $scope.requestsCollection.items[$scope.requestIndex + 1];
            if ($scope.model.attachment_count){
                AttachmentService.addAttachments($scope.model)
            };
            $scope.requestIndex += 1;
            refreshData();
        }

        $scope.preModal = function (data) {
            openstc.request.preModal(data);
        }

        $scope.preValidate = function (data) {
            return openstc.request.preValidate(data);
        }

        $scope.callback = function (error, data) {
            openstc.request.callback(error, data);
            if (data.result) {
                $scope.cancel();
            }
        }


        function openInModule() {
                $scope.cancel();
                var alert = {};
                swif.data.addFilter(alert, 'ask_id', '=', $scope.model.id)
                alert.model_id = "project.project";
                if (!alert.ui_context) {
                    alert.ui_context = {};
                }
                alert.ui_context.contentType = "intervention";
                swif.alerter.applyAlertFilter(alert);
        }
        $scope.openInModule = openInModule;
    }
})();
